import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch"];
import { useSearchTicketsQuery } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.hooks';
import { SEARCH_TICKETS_QUERY_FIELD_NAME } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.dfc.new';
import { useEffect, useState } from 'react';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { getIsPreview } from '../utils/isPreview';
import { generateDateFilter } from '../constants/filters';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
import { decodeSearchTicket } from './searchTickets';
export const DEFAULT_PAGE_LENGTH = 10;
export const LISTINGS_POLL_INTERVAL = 15000;
export const GET_TICKET_LISTINGS_SEARCH_KEY = SEARCH_TICKETS_QUERY_FIELD_NAME;
export const useTicketListingsSearch = ({
  pageLength = DEFAULT_PAGE_LENGTH,
  offset,
  pollInterval = LISTINGS_POLL_INTERVAL,
  sort,
  searchString,
  createDateFilter,
  lastActivityFilter,
  ticketView,
  statusFilter
}) => {
  const {
    isPreview
  } = getIsPreview();
  const [total, setTotal] = useState(0);
  const dateFilters = [generateDateFilter('createdate', createDateFilter), generateDateFilter('hs_lastactivitydate', lastActivityFilter)].filter(filter => filter != null);
  const _useSearchTicketsQuer = useSearchTicketsQuery({
      skip: isPreview,
      variables: {
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId(),
        params: {
          ticketView,
          statusFilter,
          searchString: searchString || undefined,
          sort,
          dateFilters,
          offset,
          pageLength
        }
      },
      pollInterval,
      skipPollAttempt: () => document.visibilityState === 'hidden'
    }),
    {
      data,
      loading,
      refetch
    } = _useSearchTicketsQuer,
    rest = _objectWithoutPropertiesLoose(_useSearchTicketsQuer, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  useEffect(() => {
    setTotal(0);
  }, [createDateFilter, lastActivityFilter, searchString, statusFilter, ticketView]);
  useEffect(() => {
    if ((data === null || data === void 0 ? void 0 : data.total) !== undefined) {
      setTotal(data.total);
    }
  }, [data]);
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.results.map(decodeSearchTicket),
    total,
    responseTotal: data === null || data === void 0 ? void 0 : data.total,
    refetch,
    loading
  }, rest);
};